import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a user successfully deletes a skill',
  name: 'skill_deleted',
  params: [
    {
      description: 'ID of the deleted skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Scope of the skill at time of deletion',
      name: 'scope',
      required: true,
      type: 'enum',
      values: ['private', 'workspace', 'builtIn'],
    },
  ],
};

export default META;
